import React, { memo } from "react";
import { GradientContainer, GradientSVG } from "./AnimatedGradientBackground.styled";
import svgPaths from "./svg-paths";

const AnimatedGradientBackground = () => {
  return (
    <GradientContainer data-name="Gradient">
      <GradientSVG
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 2189 1330"
      >
        <defs>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="2590.28"
            id="filter0_fn_63_109"
            width="1507.4"
            x="776.825"
            y="-1022.37"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_63_109" stdDeviation="188.452" />
            <feTurbulence
              baseFrequency="0.7428935170173645 0.7428935170173645"
              numOctaves="3"
              result="noise"
              seed="1582"
              stitchTiles="stitch"
              type="fractalNoise"
            />
            <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise1"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise1Clipped"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise2">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise2"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise2Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
            <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
            <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
            <feMerge result="effect2_noise_63_109">
              <feMergeNode in="effect1_foregroundBlur_63_109" />
              <feMergeNode in="color1" />
              <feMergeNode in="color2" />
            </feMerge>
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="1599.39"
            id="filter1_fn_63_109"
            width="2410.86"
            x="289.396"
            y="553.242"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_63_109" stdDeviation="188.452" />
            <feTurbulence
              baseFrequency="0.7428935170173645 0.7428935170173645"
              numOctaves="3"
              result="noise"
              seed="1582"
              stitchTiles="stitch"
              type="fractalNoise"
            />
            <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise1"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise1Clipped"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise2">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise2"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise2Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
            <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
            <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
            <feMerge result="effect2_noise_63_109">
              <feMergeNode in="effect1_foregroundBlur_63_109" />
              <feMergeNode in="color1" />
              <feMergeNode in="color2" />
            </feMerge>
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="1887.14"
            id="filter2_fn_63_109"
            width="2076.43"
            x="-390.236"
            y="433.686"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_63_109" stdDeviation="188.452" />
            <feTurbulence
              baseFrequency="0.7428935170173645 0.7428935170173645"
              numOctaves="3"
              result="noise"
              seed="1582"
              stitchTiles="stitch"
              type="fractalNoise"
            />
            <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise1"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise1Clipped"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise2">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise2"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise2Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
            <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
            <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
            <feMerge result="effect2_noise_63_109">
              <feMergeNode in="effect1_foregroundBlur_63_109" />
              <feMergeNode in="color1" />
              <feMergeNode in="color2" />
            </feMerge>
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="3398.96"
            id="filter3_fn_63_109"
            width="1638.31"
            x="-26.4706"
            y="-1798.43"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_63_109" stdDeviation="188.452" />
            <feTurbulence
              baseFrequency="0.7428935170173645 0.7428935170173645"
              numOctaves="3"
              result="noise"
              seed="1582"
              stitchTiles="stitch"
              type="fractalNoise"
            />
            <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise1"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise1Clipped"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise2">
              <feFuncA type="discrete" />
            </feComponentTransfer>
            <feComposite
              in="coloredNoise2"
              in2="effect1_foregroundBlur_63_109"
              operator="in"
              result="noise2Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
            <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
            <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
            <feMerge result="effect2_noise_63_109">
              <feMergeNode in="effect1_foregroundBlur_63_109" />
              <feMergeNode in="color1" />
              <feMergeNode in="color2" />
            </feMerge>
          </filter>
          <clipPath id="clip0_63_109">
            <rect fill="white" height="1330" width="2189" />
          </clipPath>
        </defs>
        <g clipPath="url(#clip0_63_109)" id="Gradient">
          <rect fill="black" height="1330" width="2189" />
          <g filter="url(#filter0_fn_63_109)" id="Vector-15" className="vector-15">
            <path d={svgPaths.p3862c300} fill="#D9D9D9" />
            <path d={svgPaths.p3862c300} fill="#00B5D9" />
            <path d={svgPaths.p3862c300} stroke="black" strokeWidth="2.69218" />
          </g>
          <g filter="url(#filter1_fn_63_109)" id="Vector-16" className="vector-16">
            <path d={svgPaths.p2d74c5f0} fill="#D9D9D9" />
            <path d={svgPaths.p2d74c5f0} fill="#09E2AB" />
            <path d={svgPaths.p2d74c5f0} stroke="black" strokeWidth="2.69218" />
          </g>
          <g filter="url(#filter2_fn_63_109)" id="Vector-13" className="vector-13">
            <path d={svgPaths.p22a92300} fill="#D9D9D9" />
            <path d={svgPaths.p22a92300} fill="#7B27ED" />
            <path d={svgPaths.p22a92300} stroke="black" strokeWidth="2.69218" />
          </g>
          <g filter="url(#filter3_fn_63_109)" id="Vector-14" className="vector-14">
            <path d={svgPaths.p3d6d4900} fill="#D9D9D9" />
            <path d={svgPaths.p3d6d4900} fill="#1B72FF" />
            <path d={svgPaths.p3d6d4900} stroke="black" strokeWidth="2.69218" />
          </g>
        </g>
      </GradientSVG>
    </GradientContainer>
  );
};

export default memo(AnimatedGradientBackground);
